import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const FtpNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="ftp" />;
};
